import React from "react";
import { motion } from "framer-motion";

export const SectionHeading = ({ label, title, sub, center, light }) => {
  return (
    <div className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
      {label && (
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="section-label mb-4"
        >
          {label}
        </motion.div>
      )}
      <motion.h2
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.05 }}
        className={`font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight font-bold ${
          light ? "text-white" : "text-white"
        }`}
      >
        {title}
      </motion.h2>
      {sub && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.12 }}
          className="mt-5 text-base leading-relaxed text-[#AAB6C6]"
        >
          {sub}
        </motion.p>
      )}
    </div>
  );
};

export default SectionHeading;
